/* eslint-disable import/prefer-default-export */

/**
 * @param {string} className - `className` property of `HTMLElement`
 * @returns {string} selector based on element's CSS class(es)
 */
const getClassesSelector = className => {
    const classSelector = className.split(' ').filter(elementClass => elementClass !== '');
    classSelector.unshift('');
    return classSelector.join('.');
};

/**
 * @param {HTMLElement} element - element to generate selector for.
 * @returns {string} selector.
 */
export const elementToSelector = element => {
    if (element.id) return `#${element.id}`;
    if (element.className) return getClassesSelector(element.className);
    if (element.name) return `${element.tagName}[name='${element.name}']`;
    if (element.value) return `${element.tagName}[value='${element.value}']`;

    return element.tagName;
};
